import { db } from "../../firebase";
import { Observable } from "rxjs";

// NOTE: the `aggregates` read rule is `resource.data.accountId == request.auth.token.accountId`.
// Firestore rules are not filters — a list/onSnapshot is denied outright unless the query itself
// is provably constrained to allowed docs. Every query here must filter on `accountId`.

export function getDashboardStats(user) {
  return new Observable(subscriber => {
    db.collection("aggregates")
      .where("accountId", "==", user.accountId)
      .onSnapshot(
        result => {
          subscriber.next(result.docs);
        },
        error => {
          console.error("getDashboardStats snapshot failed", error);
          subscriber.error(error);
        }
      );
  });
}

export function getBusinessStats(user) {
  return new Observable(subscriber => {
    db.collection("aggregates")
      .where("accountId", "==", user.accountId)
      .where("businessId", "==", user.businessId)
      .onSnapshot(
        result => {
          subscriber.next(result.docs);
        },
        error => {
          console.error("getBusinessStats snapshot failed", error);
          subscriber.error(error);
        }
      );
  });
}
